import { IndexRoute } from '@jxl/route-index';

export default IndexRoute;
